module.exports = __webpack_public_path__ + "img/Moonbase_import.06c9b81b.gif";